module.exports = __webpack_public_path__ + "img/PT280.32a1bfe5.png";